import { useTranslation } from 'react-i18next';

import { FrameworkPreview } from './FrameworkPreview';
import './FrameworkPage.css';

/**
 * /framework — reference page for the Te Pou Mataaho framework structure.
 *
 * Previously rendered inline on the home page; promoted to its own route
 * so it's discoverable as documentation rather than crowding the kaimahi
 * landing. Read-only — the working profile editor lives at /whanau/:id.
 */
export function FrameworkPage() {
  const { t } = useTranslation();

  return (
    <article className="framework-page" aria-labelledby="framework-title">
      <header className="framework-page__header">
        <h2 id="framework-title" className="framework-page__title">
          {t('frameworkPage.title')}
        </h2>
        <p className="framework-page__subtitle">
          {t('frameworkPage.subtitle')}
        </p>
      </header>

      <FrameworkPreview />
    </article>
  );
}

export default FrameworkPage;
